import { PublishedWorkShiftDto, PublishedWorkShiftQueryParameters } from "../models/publishedWorkShift/publishedWorkShift";
import { apiCall } from "./apiClient";

export const getPublishedWorkShifts = async(
    params: PublishedWorkShiftQueryParameters,
    signal?: AbortSignal
) => {
    const response = await apiCall<
        PublishedWorkShiftDto[],
        PublishedWorkShiftQueryParameters
    >("PlannedWorkShifts/published", "GET", params, signal);
    return response.data;
};
